const theme2 = (data) => {
  const node = data.node;
  const title = node.title;
  const color = data.color;
  const date = new Date();
  const year = date.getFullYear(); //获取完整的年份(4位)
  const month = date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
  const strDate = date.getDate(); // 获取当前日(1-31)

  return {
    id: "b3C7RwXoyf",
    elements: [
      {
        type: "shape",
        id: "8htPIchx66",
        width: 7.36241469816273,
        height: 7.0890288713910765,
        left: 927.4434645669292,
        top: 27.249973753280837,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "UiZDcG1UZV",
        width: 7.36241469816273,
        height: 7.0890288713910765,
        left: 962.6375853018372,
        top: 27.249973753280837,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "AeDgUK_8oq",
        width: 35.77753280839895,
        height: 7.0890288713910765,
        left: 930.6410498687665,
        top: 27.249973753280837,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "hEZVdgY_a3",
        width: 7.36241469816273,
        height: 7.0890288713910765,
        left: 927.4434645669292,
        top: 41.71181102362205,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "zof2DCxnhi",
        width: 7.36241469816273,
        height: 7.0890288713910765,
        left: 962.6375853018372,
        top: 41.71181102362205,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "-wXCx7PGf8",
        width: 35.77753280839895,
        height: 7.0890288713910765,
        left: 930.6410498687665,
        top: 41.71181102362205,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "HEGLMp30Zf",
        width: 7.36241469816273,
        height: 7.0890288713910765,
        left: 927.4434645669292,
        top: 56.173648293963254,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "jBq95xlMeY",
        width: 7.36241469816273,
        height: 7.0890288713910765,
        left: 962.6375853018372,
        top: 56.173648293963254,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "-0riaz0Zk2",
        width: 35.77753280839895,
        height: 7.0890288713910765,
        left: 930.6410498687665,
        top: 56.173648293963254,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "WqlFaJ6LEh",
        width: 19.029396325459317,
        height: 19.029396325459317,
        left: 356.05102362204724,
        top: 305.2499737532808,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "TzJid_vGKk",
        width: 17.670236220472443,
        height: 17.670236220472443,
        left: 383.78519685039373,
        top: 305.9296587926509,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "iw1l3tGwt2",
        width: 16.310971128608923,
        height: 16.310971128608923,
        left: 410.1602099737533,
        top: 306.6092388451444,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "JcdHLdBnsU",
        width: 14.951706036745406,
        height: 14.951706036745406,
        left: 434.1552755905512,
        top: 307.2889238845145,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "M5dZ_wwbpK",
        width: 13.59244094488189,
        height: 13.59244094488189,
        left: 457.81175853018374,
        top: 307.9685039370079,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "rF64-cnFpe",
        width: 713.2275065616798,
        height: 83.28125,
        left: 77.54152230971128,
        top: 159.24741812094254,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 42.1875px;font-family: Microsoft Yahei;">${title}</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "shape",
        id: "vp2GixwsVp",
        width: 8.093018372703412,
        height: 8.093018372703412,
        left: 31.843359580052493,
        top: 27.533648293963257,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "BN_EKgLZjY",
        width: 7.51496062992126,
        height: 7.51496062992126,
        left: 43.392860892388455,
        top: 27.249973753280837,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "fP6e9UOXew",
        width: 7.1847769028871395,
        height: 7.1847769028871395,
        left: 54.364304461942254,
        top: 27.41511811023622,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "w29Rc0Rnt3",
        width: 6.659107611548556,
        height: 6.659107611548556,
        left: 65.0054593175853,
        top: 28.277795275590552,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "oEwFD9dIv7",
        width: 6.3085564304461945,
        height: 6.3085564304461945,
        left: 75.1210498687664,
        top: 27.88031496062992,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "2bU-8bNbg-",
        width: 8.093018372703412,
        height: 8.093018372703412,
        left: 31.843359580052493,
        top: 38.860787401574804,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "7fEggXOFtr",
        width: 7.51496062992126,
        height: 7.51496062992126,
        left: 43.392860892388455,
        top: 38.57711286089239,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "ffNCuOt8gU",
        width: 7.1847769028871395,
        height: 7.1847769028871395,
        left: 54.364304461942254,
        top: 38.74215223097113,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "CY4JpOsLH7",
        width: 6.659107611548556,
        height: 6.659107611548556,
        left: 65.0054593175853,
        top: 39.60482939632546,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "ncA70ciqpJ",
        width: 6.3085564304461945,
        height: 6.3085564304461945,
        left: 75.1210498687664,
        top: 39.20734908136483,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "rSQ7JtnoZ5",
        width: 8.093018372703412,
        height: 8.093018372703412,
        left: 31.843359580052493,
        top: 50.18782152230972,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "3yFuCp8MYh",
        width: 7.51496062992126,
        height: 7.51496062992126,
        left: 43.392860892388455,
        top: 49.9041469816273,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "HsplOl-Tt0",
        width: 7.1847769028871395,
        height: 7.1847769028871395,
        left: 54.364304461942254,
        top: 50.06918635170604,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "Popw3DE_2j",
        width: 6.659107611548556,
        height: 6.659107611548556,
        left: 65.0054593175853,
        top: 50.93196850393701,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "JEGQnxBwVP",
        width: 6.3085564304461945,
        height: 6.3085564304461945,
        left: 75.1210498687664,
        top: 50.53438320209973,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "OHY_DktTsV",
        width: 8.093018372703412,
        height: 8.093018372703412,
        left: 31.843359580052493,
        top: 61.51485564304462,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "k7GL_dqTxX",
        width: 7.51496062992126,
        height: 7.51496062992126,
        left: 43.392860892388455,
        top: 61.23118110236221,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "MAnNXbmmDL",
        width: 7.1847769028871395,
        height: 7.1847769028871395,
        left: 54.364304461942254,
        top: 61.39632545931759,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "lS-T2E-9Vd",
        width: 6.659107611548556,
        height: 6.659107611548556,
        left: 65.0054593175853,
        top: 62.259002624671915,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "qZhoUxTqmy",
        width: 6.3085564304461945,
        height: 6.3085564304461945,
        left: 75.1210498687664,
        top: 61.86152230971128,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "6aFXgwf3s4",
        width: 248.7272440944882,
        height: 2,
        left: 111.19800524934382,
        top: 314.3047769028871,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "ohk9gDAl25",
        width: 369.7220997375328,
        height: 369.7220997375328,
        left: 749.4597375328084,
        top: 352.73679790026245,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "0Ok-ZsWGUg",
        width: 653.2550131233596,
        height: 50,
        left: 101.19800524934382,
        top: 361.1108661417323,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        content:
          '<p style="text-align: left;"><span style="font-size: 16.40625px;font-family: Microsoft Yahei;">汇报人：Chat PPT</span></p>',
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "b1d0ICNhJf",
        width: 600,
        height: 50,
        left: 101.19800524934382,
        top: 411.0310761154856,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 16.40625px;font-family: Microsoft Yahei;">${year}年${month}月${strDate}日</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "shape",
        id: "_MsiHmYvvX",
        left: 39.936377952755905,
        top: 496.56877698075135,
        width: 15,
        height: 15.451174289245984,
        viewBox: [200, 200],
        path: "M 0 0 L 80 0 L 200 100 L 80 200 L 0 200 L 120 100 L 0 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
      },
      {
        type: "shape",
        id: "e_b6NBp4HV",
        left: 52.936377952755905,
        top: 496.56877698075135,
        width: 15,
        height: 15.451174289245984,
        viewBox: [200, 200],
        path: "M 0 0 L 80 0 L 200 100 L 80 200 L 0 200 L 120 100 L 0 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
      },
      {
        type: "shape",
        id: "n0Fs_Zg8v3",
        left: 66.55120803039298,
        top: 496.56877698075135,
        width: 15,
        height: 15.451174289245984,
        viewBox: [200, 200],
        path: "M 0 0 L 80 0 L 200 100 L 80 200 L 0 200 L 120 100 L 0 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
      },
    ],
    background: {
      type: "solid",
      color: `#fff`,
    },
  };
};

export default theme2;
